import { FS_FORCED_VARIATIONS } from '../../enum/FlagshipConstant';
import { logInfoSprintf } from '../../utils/utils';
import { loadQaAssistant } from './loadQaAssistant';
/**
 *
 * @param config
 */
export function listenForKeyboardQaAssistant(config, visitorVariationState) {
    logInfoSprintf(config, 'QA assistant', 'Listening for keyboard events to launch QA Assistant');
    if (window.__flagshipSdkOnKeyCombinationDown) {
        document.removeEventListener('keydown', window.__flagshipSdkOnKeyCombinationDown);
    }
    if (window.__flagshipSdkOnKeyCombinationUp) {
        document.removeEventListener('keyup', window.__flagshipSdkOnKeyCombinationUp);
    }
    const keysPressed = {};
    const keyCombinationPressed = () => {
        return (keysPressed.Control || keysPressed.Alt) && keysPressed.q && keysPressed.a;
    };
    window.__flagshipSdkOnKeyCombinationDown = (event) => {
        keysPressed[event.key] = true;
        sessionStorage.removeItem(FS_FORCED_VARIATIONS);
        if (keyCombinationPressed()) {
            loadQaAssistant(config, null, visitorVariationState);
        }
    };
    window.__flagshipSdkOnKeyCombinationUp = (event) => {
        delete keysPressed[event.key];
    };
    document.addEventListener('keydown', window.__flagshipSdkOnKeyCombinationDown);
    document.addEventListener('keyup', window.__flagshipSdkOnKeyCombinationUp);
}
